import React, { useEffect, useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  Box, CardMedia, Tab, Tabs, Typography,
} from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { useHistory } from 'react-router-dom';
import GlobalLoader from 'Shared/GlobalLoader/GlobalLoader';
import { toast } from 'react-toastify';
import useStyles from './style';
import { getCarFamilies, getVehiculesByCarIds } from '../ExternSearchServices';

const ModelDetailView = ({ location }) => {
  const classes = useStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [families, setFamilies] = useState([]);
  const [selectedFamily, setSelectedFamily] = useState(0);
  const [carInfo, setCarInfo] = useState({});

  const { state } = location;
  const renderTree = ({ assemblyGroupNodeId, subFamilies, ...nodes }) => {
    const navigateToArticle = (ref) => history.push(`/externe-search?carId=${state.carId}&familyId=${ref}`);

    return (
      <TreeItem
        key={assemblyGroupNodeId}
        nodeId={assemblyGroupNodeId}
        label={(
          <Typography
            onClick={!subFamilies ? () => navigateToArticle(assemblyGroupNodeId) : null}
          >
            {nodes.assemblyGroupName}
          </Typography>
        )}
        classes={{ label: classes.labelItemTree }}
      >
        {Array.isArray(subFamilies) ? subFamilies.map((node) => renderTree(node)) : null}
      </TreeItem>
    );
  };
  useEffect(async () => {
    if (state.carId) {
      setLoading(true);
      try {
        const dataRep = await getCarFamilies(state.carId);
        setFamilies(dataRep);
      } catch (e) {
        toast.error(e.message);
      } finally {
        setLoading(false);
      }
    }
  }, [state.carId]);
  useEffect(async () => {
    if (state.carId) {
      setLoading(true);
      try {
        const carsInfo = await getVehiculesByCarIds([state.carId]);
        const carExtraInfo = carsInfo.find((car) => car.carId === state.carId)
          ?.vehicleDetails || state;
        setCarInfo(carExtraInfo);
      } catch (e) {
        toast.error(e.message);
      } finally {
        setLoading(false);
      }
    }
  }, [state.carId]);
  return (
    <Box style={{ height: '100vh', overflowY: 'auto' }}>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          columnGap: 10,
          paddingLeft: 5,
        }}
      >
        <ArrowBackIcon
          style={{ fontSize: '32px', cursor: 'pointer' }}
          onClick={() => history.push('/externe-search')}
        />
        <Typography style={{ font: 'normal normal 600 32px/39px Montserrat', color: '#000000' }}>
          {state.name}
        </Typography>
      </Box>
      <Box sx={{ ml: 3, mr: 2 }}>
        <Typography
          style={{
            font: 'normal normal 600 20px/24px Montserrat',
            color: '#007BC6',
            textTransform: 'uppercase',
          }}
        >
          {state.vin}
        </Typography>
        <Box sx={{ display: 'flex', overflow: 'hidden' }}>
          <Box className={classes.cardContainer}>
            <CardMedia
              src={state.img}
              component="img"
              style={{ width: '313px', maxHeight: '235px', borderRadius: '12px' }}
            />
            <Box className={classes.card} style={{ borderLeft: 'none' }}>
              <Typography className={classes.cardTitle}>TYPE VÉHICULE</Typography>
              <Typography className={classes.cardValue}>{carInfo.modelName}</Typography>
            </Box>
            <Box className={[classes.card, classes.cardEven]}>
              <Typography className={classes.cardTitle}>ANNÉE DE CONSTRUCTION</Typography>
              <Typography className={classes.cardValue}>{state.beginYear}</Typography>
            </Box>
            <Box className={classes.card}>
              <Typography className={classes.cardTitle}>PUISSANCE</Typography>
              <Typography className={classes.cardValue}>{`${carInfo.powerKwTo || '-'} Kw / ${carInfo.powerHpTo || '-'} Cv`}</Typography>
            </Box>
            <Box className={[classes.card, classes.cardEven]}>
              <Typography className={classes.cardTitle}>CYLINDRÉE</Typography>
              <Typography className={classes.cardValue}>{`${carInfo.cylinderCapacityCcm || '-'} Cm / ${carInfo.cylinderCapacityLiter || '-'} L`}</Typography>
            </Box>
            <Box className={classes.card}>
              <Typography className={classes.cardTitle}>CYLINDRES</Typography>
              <Typography className={classes.cardValue}>{carInfo.cylinder}</Typography>
            </Box>
            <Box className={[classes.card, classes.cardEven]}>
              <Typography className={classes.cardTitle}>SOUPAPES</Typography>
              <Typography className={classes.cardValue}>{carInfo.valves}</Typography>
            </Box>
            <Box className={classes.card}>
              <Typography className={classes.cardTitle}>TYPE DE CARROSSERI</Typography>
              <Typography className={classes.cardValue}>{carInfo.constructionType}</Typography>
            </Box>
            <Box className={[classes.card, classes.cardEven]}>
              <Typography className={classes.cardTitle}>TYPE DE MOTRICITÉ</Typography>
              <Typography className={classes.cardValue}>{carInfo.impulsionType}</Typography>
            </Box>
            <Box className={classes.card}>
              <Typography className={classes.cardTitle}>TYPE DE MOTEUR</Typography>
              <Typography className={classes.cardValue}>{carInfo.motorType}</Typography>
            </Box>
            <Box className={[classes.card, classes.cardEven]}>
              <Typography className={classes.cardTitle}>CODES MOTEUR</Typography>
              <Typography className={classes.cardValue}>{state.engineCode}</Typography>
            </Box>
            <Box className={classes.card}>
              <Typography className={classes.cardTitle}>TYPE CARBURANT</Typography>
              <Typography className={classes.cardValue}>{carInfo.fuelType}</Typography>
            </Box>
            <Box className={[classes.card, classes.cardEven]}>
              <Typography className={classes.cardTitle}>SYSTEME DE CARBURATION</Typography>
              <Typography className={classes.cardValue}>{carInfo.fuelTypeProcess}</Typography>
            </Box>
          </Box>
          <Box sx={{ overflow: 'hidden' }}>
            <Tabs
              value={selectedFamily}
              onChange={(e, target) => setSelectedFamily(target)}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                '& .MuiTab-root': { background: '#fff' },
                '& .MuiTabs-flexContainer': { columnGap: 1 },
                '& .MuiTabs-scroller': { paddingBottom: '30px' },
                '& .MuiTabs-indicator': {
                  borderLeft: '20px solid transparent',
                  borderRight: '20px solid transparent',
                  borderBottom: '30px solid #ebe9e9',
                  height: 'unset',
                  width: 'unset !important',
                  backgroundColor: 'unset',
                },
              }}
            >
              {families.map((family) => (
                <Tab
                  key={family.assemblyGroupNodeId}
                  icon={<LinkIcon />}
                  iconPosition="start"
                  label={family.assemblyGroupName}
                />
              ))}
            </Tabs>
            <Box className={classes.categories}>
              {loading && <GlobalLoader size="100%" style={{ position: 'absolte' }} />}
              <TreeView
                className={classes.root}
                defaultCollapseIcon={<ExpandMoreIcon />}
                defaultExpanded={['root']}
                defaultExpandIcon={<ChevronRightIcon />}
              >
                {families[selectedFamily] && renderTree(families[selectedFamily])}
              </TreeView>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ModelDetailView;
